import { CartStateType } from './types'

export const CART_INITIAL_STATE: CartStateType = {
  cartItems: []
}
